<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { AuctionFilter } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import AuctionFilterForm, { DEFAULTS as FILTER_DEFAULTS } from './components/AuctionFilterForm.svelte';
    import AuctionHeader, { DEFAULTS as HEADER_DEFAULTS } from './components/AuctionHeader.svelte';
    import AuctionListItem from './components/AuctionListItem.svelte';
    import AuctionListEmpty from './components/AuctionListEmpty.svelte';

    // LAYOUT
    import LayoutInside from 'src/app/library/layouts/layout-inside/LayoutInside.svelte';

    // PLUGINS
    import { setContext } from 'svelte';

    // TYPES
    import type { Parameters } from 'src/app/types';

    /* INITIALIZE ------------------------------------------------------------------------------ */

    const DEFAULTS = { ...FILTER_DEFAULTS, ...HEADER_DEFAULTS } as Parameters;

    setContext('scope', 'auctions');

</script>

<LayoutInside>

    <svelte:fragment slot = 'main'>

        <AuctionHeader />

        <AuctionFilter defaults = { DEFAULTS } let:auctions showPagination = { false }>

            <ul class = 's8-list'>
                {#each auctions as auction}
                    <li>
                        <!-- TODO: This is due to buyer auction types deviating from generic auction types -->
                        <AuctionListItem { auction } />
                    </li>
                {/each}
            </ul>

            <svelte:fragment slot = 'empty'>
                <AuctionListEmpty />
            </svelte:fragment>

        </AuctionFilter>

    </svelte:fragment>

    <svelte:fragment slot = 'aside'>
        <AuctionFilterForm />
    </svelte:fragment>

</LayoutInside>

<style lang='postcss'>
    ul.s8-list {
        padding-bottom: 20px;
    }
</style>